import React from "react";
import { withTranslation } from "react-i18next";
import "./ContinueCancelButtons.module.scss";
import { useNavigate } from "react-router-dom";

const ContinueCancelButtons = ({
  t,
  i18n,
  continueClick,
  continueText,
  errorText,
  cancelClick,
  cancelText,
  grayButton,
  hideButton,
  isReversed,
  cancel_button
}) => {
  const navigate = useNavigate();
  const handleCancel = () => {
    if (cancelClick) {
      cancelClick();
      return;
    }
    navigate(
      `/${i18n.language}${t("routes.cancel_confirmation")}`
    );
    // const url =
    //   i18n.language === "en"
    //     ? process.env.REACT_APP_PAGE_NOT_FOUND_URL
    //     : process.env.REACT_APP_PAGE_NOT_FOUND_URL_FR;

    // window.location.replace(url);
  };

  const continueButtonClassName = grayButton
    ? "btn-lg btn.disabled"
    : "btn-lg btn-default";

  const continueBtn = (<button
    hidden={hideButton}
    style={{ marginRight: ".7em" }}
    className={continueButtonClassName}
    type="button"
    onClick={continueClick}
    disabled={grayButton}
    value={t("shared.continue")}
    name={t("shared.continue")}
  >
    {continueText ? t(continueText) : t("shared.continue")}
  </button>)

  const errMsgBtn = (errorText && errorText !== "" && (
    <>
      <i
        aria-label={t("errors.hidden_error_msg")}
        className="fa fa-exclamation-circle error-indicator ns-error-indicator errorAlert"
        aria-hidden="true"
      />
      <span className="ns-visually-hidden">
        {t("errors.hidden_error_msg")}
      </span>
    </>
  ))

  const cancelBtn = (<button
    className={`btn-lg ${cancel_button ? "btn-default " : "ns-btn-2nd"}`}
    style={{
      marginRight: ".7em",
      marginLeft: cancel_button ? '3em' : '0px'

    }}
    type="button"
    value={t("shared.cancel")}
    onClick={handleCancel}
    name={t("shared.cancel")}
  >
    {cancelText ? t(cancelText) : t("shared.cancel")}
  </button>)
  return (
    <section className="row" >
      <div className={"col-xs-12"} >
        {isReversed ? (
          <>
            {cancelBtn}
            {errMsgBtn}
            {continueBtn}
          </>
        ) : (<>
          {continueBtn}
          {errMsgBtn}
          {cancelBtn}
        </>
        )}


      </div>
      {
        errorText && errorText !== "" && (
          <span
            id="date-field-error"
            className="ns--message ns-error-message col-md-12"
          >
            <span className="ns-visually-hidden">{t("shared.error")}</span>
            <strong>{t("shared.before_continuing")}</strong>{" "}
            <span className="ns-error">{t(errorText)}</span>
          </span>
        )
      }
    </section >
  );
};

export default withTranslation("common")(ContinueCancelButtons);
